<div class="overflow-y-scroll" cdkScrollable [style.height]="height" #scrollContainer>
  <ng-content select="ctr-scroll-item"></ng-content>
</div>
